export default "<p>pages works!</p>\r\n";